import { render, staticRenderFns } from "./suppliersInfo.vue?vue&type=template&id=2e0889c3&scoped=true&"
import script from "./suppliersInfo.vue?vue&type=script&lang=js&"
export * from "./suppliersInfo.vue?vue&type=script&lang=js&"
import style0 from "./suppliersInfo.vue?vue&type=style&index=0&id=2e0889c3&lang=scss&scoped=true&"
import style1 from "./suppliersInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0889c3",
  null
  
)

export default component.exports